import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'

// Plugins
import '@/plugins/simpleAlert.js'
import '@/plugins/dayjs'
import '@/plugins/vuemq'
import '@/plugins/cookie'
import '@/plugins/session'
import i18n from './i18n'
import store from './store'

// Styles
import '@/styles/index.scss'
import common from "./mixins/common";

Vue.config.productionTip = false

Vue.mixin(common)

new Vue({
  vuetify,
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
